import Vue from "vue"
import App from "./App.vue"
import router from "./router"

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App),
    watch: {
        $route: function(to, from) {
            // show waiting svg
            this.currentMenuItem = to.path
            // wait some time before closing the menu - calculations take some time
            setTimeout(this.hideMenu, 500)
        }
    },
    methods: {
        hideMenu() {
            document.getElementById("burger").checked = false
            this.currentMenuItem = ""
        }
    },
    data() {
        return {
            unsplashURL: "//unsplash.com/",
            unsplashUTM:
                "?utm_source=photoviz&utm_medium=referral&utm_campaign=",
            currentMenuItem: "",
            baseURL: window.location.origin
        }
    }
}).$mount("#app")
